import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const { FiUsers, FiGift, FiMapPin, FiClock } = FiIcons;

const KpiCard = ({ label, value, icon, colorClass, trend, delay }) => (
  <div
    className="bg-white rounded-2xl border border-surface-200 shadow-card hover:shadow-card-hover transition-all duration-300 p-5 group animate-fade-up"
    style={{ animationDelay: `${delay}ms` }}
  >
    <div className="flex items-center justify-between mb-4">
      <div className={`w-12 h-12 rounded-2xl ${colorClass} flex items-center justify-center shadow-lg shadow-current/10 group-hover:scale-110 transition-transform duration-300`}>
        <SafeIcon icon={icon} className="w-6 h-6 text-white" />
      </div>
      <span className="text-[10px] font-bold px-2 py-1 rounded-lg bg-surface-50 text-surface-500 border border-surface-100 uppercase tracking-wider">
        {trend}
      </span>
    </div>
    <div>
      <p className="text-xs font-semibold text-surface-400 uppercase tracking-widest mb-1">{label}</p>
      <h3 className="text-2xl font-extrabold text-surface-900 tabular-nums tracking-tight">
        {value?.toLocaleString() ?? '0'}
      </h3>
    </div>
  </div>
);

const KpiSection = ({ data }) => {
  const stats = [
    { label: 'Total Enrolled', value: data?.total_users, icon: FiUsers, colorClass: 'bg-indigo-600', trend: 'Scheme' },
    { label: 'Gifts Claimed', value: data?.gift_selected, icon: FiGift, colorClass: 'bg-emerald-500', trend: 'Active' },
    { label: 'Address Completed', value: data?.address_collected, icon: FiMapPin, colorClass: 'bg-sky-500', trend: 'Verified' },
    { label: 'Pending Actions', value: data?.pending_users, icon: FiClock, colorClass: 'bg-amber-500', trend: 'Waiting' },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat, idx) => (
        <KpiCard key={idx} {...stat} delay={idx * 50} />
      ))}
    </div>
  );
};

export default KpiSection;